export enum LanguagesEnum {
    ENGLISH = 1,
    SPANISH = 2,
    CATALAN = 3,
}
